const linkButtons = document.querySelectorAll('[js-link-button]');
linkButtons.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    const linkContents = document.querySelectorAll('[js-child-content]');
    const title = link.getAttribute('data-value');

    if (link.classList.contains('active')) {
      link.classList.remove('active');
      
      linkContents.forEach(content => {
        content.classList.add('hidden');
      });
    } else {
      link.classList.add('active');

      linkContents.forEach(content => {
        const content_title = content.getAttribute('data-value');
  
        if (title == content_title) {
          content.classList.remove('hidden');
        } else {
          content.classList.add('hidden');
        }
      });
    }
  });
});

const childLinkButtons = document.querySelectorAll('[js-child-link-button]');

childLinkButtons.forEach(button => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const title = button.getAttribute('data-value');

    if (button.classList.contains('active')) {
      button.classList.remove('active');
      const childLinkContents = document.querySelectorAll('[js-grand-child-content]');
      childLinkContents.forEach(content => {
        content.classList.add('hidden');
      });
    } else {
      button.classList.add('active');

      const childLinkContents = document.querySelectorAll('[js-grand-child-content]');
      childLinkContents.forEach(content => {
        const content_title = content.getAttribute('data-value');

        if (title == content_title) {
          content.classList.remove('hidden');
        } else {
          content.classList.add('hidden');
        }
      }); 
    }
  });
});

const closeSearchBtn = document.querySelector('[js-search-close-button]');
if (closeSearchBtn) {
  closeSearchBtn.addEventListener('click', (e) => {
    e.preventDefault();

    const input = closeSearchBtn.parentNode.querySelector('.search-form__input');
    if (input) input.value = '';

    window.location.href = window.location.href.split('?')[0]; 
  });
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
      c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
      }
  }
  return "";
}

// new facts

// this.filterTags();
// this.filterPrices();
// this.renderFilter();
// this.sortEvents();
// this.renderPaginate();
// this.eventFacetsRemove();
// this.renderFacetsRemove(window.location.href);

const recentlyElements = document.querySelectorAll('[js-recently-viewed]');
let recently_product, recommendations = [];;

recentlyElements.forEach(element => {
  const limit_count = element.getAttribute('data-limit');
  const column_count = element.getAttribute('data-column-count');

  const recently_handle = getCookie('recently_viewed_product');
  console.log('recently_handle = ', recently_handle);
  if (recently_handle) {
    fetch(`/products/${recently_handle}.json`).then(res => res.json()).then(response => {
      if (response && response.product) {
        recently_product = response.product;
        getRecommendationProducts(limit_count, column_count, element);
      }
    });
  }
});

function getRecommendationProducts(limit_count, column_count, element) {
  fetch(`/recommendations/products.json?product_id=${recently_product.id}&limit=${limit_count}`).then(res => res.json()).then(response => {
    if (response.products.length > 0) {
      recently_product.url = `/products/${recently_product.handle}`;
      recommendations.push(recently_product);
      response.products.forEach(product => {
        recommendations.push(product);
      });
    } else {
      recommendations.push(recently_product);
    }

    if (recommendations.length > 1) {
      element.parentNode.classList.remove('hidden');
    }

    renderHtml(column_count, element);
  });
}

function renderHtml(column_count, element) {
  let result_html = '';

  recommendations.forEach((product, index) => {
    let tagNew = false, tagCustom = false , tags = [];
    if (index == 0 ){ 
      tags = product.tags.split(', ');
    } else {
      tags = product.tags;
    }

    tags.forEach(tag => {
      if (tag == 'new' || tag == 'New') {
        tagNew = true;
      } else if (tag == 'badge' || tag == 'Badge') {
        tagCustom = true;
      }
    });

    const item_html = `
      <div class="halo-item swiper-slide">
        <div class="product-card">
          <div class="product-image">
            ${index == 0 ? '<div class="recently-viewed-badge">You viewed...</div>': ''}
            <div class="product_badges" style="display: none;">
              ${ tagNew ? `<div class="badge new-badge">New</div>`: '' }
              ${ product.compare_at_price_min > product.price_min ? '<div class="badge sale-badge">Sale</div>': '' }
              ${ !product.available ? '<div class="badge soldOut-badge">Sold out</div>': '' }
              ${ tagCustom ? '<div class="badge custom-badge">Custom Label</div>': '' }
            </div>

            <a class="product-link image-swap" href="${product.url}">
              ${
                index == 0 ?
                product.images[1] ? 
                `
                <img src="${product.images[0].src}" class="image-one" width="300" height="300" loading="lazy" alt="${product.title}"/>
                <img src="${product.images[1].src}" class="image-two" width="300" height="300" loading="lazy" alt="${product.title}"/>
                `
                :
                `<img src="${product.images[0].src}" alt="${product.title}" width="300" height="300" loading="lazy"/>`
                :
                
                product.images[1] ? 
                `
                <img src="${product.images[0]}" class="image-one" width="300" height="300" loading="lazy" alt="${product.title}"/>
                <img src="${product.images[1]}" class="image-two" width="300" height="300" loading="lazy" alt="${product.title}"/>
                `
                :
                `<img src="${product.images[0]}" alt="${product.title}" width="300" height="300" loading="lazy"/>`
                
              }
            </a>
          </div>

          <div class="product-content">
            <div class="product-price ${product.compare_at_price_min > product.price_min || Number(product.variants[0].compare_at_price) > Number(product.variants[0].price) ? ' price--on-sale': ''}" data-price>
              ${
                index == 0 ?
                Number(product.variants[0].compare_at_price) > Number(product.variants[0].price) ? 
                `
                  <span class="price-item price-item--regular" data-regular-price>
                      <span class="money">${Shopify.formatMoney(Number(product.variants[0].compare_at_price) * 100, window.money_format)}</span>
                  </span>
                  <span class="price-item price-item--sale">
                      <span class="money">${Shopify.formatMoney(Number(product.variants[0].price) * 100, window.money_format)}</span>
                  </span>
                `:
                `
                <span class="price-item price-item--regular" data-regular-price>
                  <span class="money">${Shopify.formatMoney(Number(product.variants[0].price) * 100, window.money_format)}</span>
                </span>
                `
                :
                product.compare_at_price_min > product.price_min ? 
                `
                  <span class="price-item price-item--regular" data-regular-price>
                      <span class="money">${Shopify.formatMoney(product.compare_at_price_min, window.money_format)}</span>
                  </span>
                  <span class="price-item price-item--sale">
                      <span class="money">${Shopify.formatMoney(product.price_min, window.money_format)}</span>
                  </span>
                `:
                `
                <span class="price-item price-item--regular" data-regular-price>
                  <span class="money">${Shopify.formatMoney(product.price_min, window.money_format)}</span>
                </span>
                `
              }
            </div>

            <h4 class="product-title">
              <a href="${product.url}">${product.title}</a>
            </h4>
          </div>
        </div>
      </div>
    `;

    result_html += item_html;
  });

  element.innerHTML = `
    <div class="swiper-wrapper">
      ${result_html}
    </div>

    <div class="swiper-button-next">
      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 478.448 478.448"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
    </div>
    
    <div class="swiper-button-prev">
      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 370.814 370.814"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
    </div>
    
    <div class="swiper-pagination"></div>
  `;

  new Swiper(element, {
    slidesPerView: 5,
    spaceBetween: 16,
    loop: false,
    navigation: {
      nextEl: ".recently-viewed-section__content .swiper-button-next",
      prevEl: ".recently-viewed-section__content .swiper-button-prev",
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      320: {
        slidesPerView: 2
      },
      661: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 3,
        
      },
      991: {
        slidesPerView: 4,
      },
      1100: {
        slidesPerView: 5
      }
    }
  })
}

// const productButton = document.querySelector('.product-form__cart-submit');
// if (productButton) {
//   productButton.addEventListener('click', (e) => {
//     e.preventDefault();
//     const form = document.querySelector('.product_form_wrapper form.product-form');
//     if (form) {
//       form.submit();
//     } else {

//     }
//     console.log('clicked')
//   });
// }
// initPriceSpans();
function initPriceSpans() {
  const searchInput = document.querySelector('.header-search .header-search__form .header-search__input');
  const resultProductsHtml = document.querySelector('.snize-ac-results-content .snize-ac-results-multicolumn-list');

  let searchTimer = setInterval(() => {
    const searchProducts = document.querySelectorAll('.snize-search-results-main-content .snize-search-results-content .snize-product');
    if (searchProducts.length > 0 && searchProducts[0].classList.length > 1) {
      clearInterval(searchTimer);

      searchProducts.forEach(sProduct => {
        const priceList = sProduct.querySelectorAll('.snize-price-list span');
        priceList.forEach(price => {

          if (!price.classList.contains('snize-save-price-wrapper')) {
            // if (!price.innerHTML.includes('<p>Was:')) {
            //   price.setAttribute('data-money', price.innerHTML);
            // } else {
            //   price.setAttribute('data-money', price.innerHTML.split('<p>Was: </p>')[1]);
            // }
            price.setAttribute('data-money', '');
          }

          setTimeout(() => {
            if (price.classList.contains('snize-discounted-price') && !price.innerHTML.includes('Was:')) {
              // price.innerHTML = `<p>Was: </p>${price.innerHTML}`;
            }
          }, 100);
        });
      });
    }
  }, 1000);

  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      if (resultProductsHtml) resultProductsHtml.classList.add('hidden');
      setTimeout(() => {
        const acProducts = document.querySelectorAll('.snize-ac-results-content .snize-ac-results-multicolumn-list li.snize-product');
        acProducts.forEach(acProduct => {
          const priceList = acProduct.querySelectorAll('.snize-price-list span');
          priceList.forEach(price => {
            if (!price.classList.contains('snize-save-price-wrapper')) {
              price.setAttribute('data-money', '');
            }

            if (price.classList.contains('snize-discounted-price') && !price.innerHTML.includes('<p>Was:')) {
              // price.innerHTML = `<p>Was: </p>${price.innerHTML}`;
            }
          });
        });

        if (resultProductsHtml) resultProductsHtml.classList.remove('hidden');
      }, 1000);
    })
  }
}


document.addEventListener('Searchanise.Loaded', function () {
  (function ($) {
    $(document).on('Searchanise.AutocompleteUpdated', function(event, container) {
      console.log('search app result update');
      initPriceSpans();
    });
    document.addEventListener('DOMContentLoaded', function() {
      if (document.querySelector('.snize-main-panel-dropdown')) {
        document.querySelector('.snize-main-panel-dropdown').addEventListener('mouseover', function () {
            console.log('mouseover action');
            const dropdown = document.querySelector('.snize-main-panel-dropdown-content');
            if (dropdown) {
                dropdown.style.display = 'none';
            }
            return;
        });
      }
    });
  })(window.Searchanise.$);
});

document.addEventListener('DOMContentLoaded', function() {
  fetch('/?section_id=header').then(res => res.text()).then(response => {
    // const parser = new DOMParser();
    // const doc = parser.parseFromString(response, 'text/html');
    // const header = doc.querySelector('.header');
    // console.log('doc = ', doc);
  });

  let accountAction = document.querySelector('[js-account-dropdown]');
  if (accountAction) {
    accountAction.addEventListener('click', function() {
      let accountDropdown = document.querySelector('.account-dropdown');
      accountDropdown.classList.toggle('active');
    });
  }
});

$(document).on('Searchanise.ResultsUpdated', function(event, container) {
  console.log('search app result update');
  initPriceSpans();
});